import gql from 'graphql-tag'

export const QUERY_GET_COUPONS = gql`
  query Coupons(
    $page: Int!
    $pageSize: Int!
    $sort: [String]
    $sortDirection: [SortDirection]
    $user: ID
    $initialDate: String
    $finalDate: String
    $units: [ID]
    $units_configuration: [UnitConfigurationInput]
  ) {
    coupons(
      page: $page
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
      user: $user
      initialDate: $initialDate
      finalDate: $finalDate
      units: $units
      units_configuration: $units_configuration
    ) {
      records
      page
      coupons {
        id
        unit {
          name
        }
        products_count
        total_products_quantity
        revenue
        purchased_at
      }
    }
  }
`

export const QUERY_GET_COUPON_ITEMS = gql`
  query Coupon($id: ID!) {
    coupon(id: $id) {
      id
      unit {
        _id
        name
        id_erp
        address
        mobile
      }
      products_count
      total_products_quantity
      revenue
      discount_price
      purchased_at
      purchased_at_datetime
      items {
        product {
          sku
          name
        }
        quantity
        revenue
        product_with_discount_quantity
      }
    }
  }
`
